import cx from 'classnames';
import React from 'react';

import * as styles from './styles.css';
import Box, { BoxProps } from '../Box';

interface MenuTitleProps extends BoxProps {
  title: string;
}

const MenuTitle: React.FC<MenuTitleProps> = ({ title, className, ...rest }) => {
  return (
    <Box element="h4" className={cx(className, styles['menu-item'], styles['menu-item-title'])} {...rest}>
      {title}
    </Box>
  );
};

export default MenuTitle;
